import { createSelector } from 'reselect';
import { LoadingStatusEnum } from '../types';

import type { RootState } from 'modules/store/types';

export const getCourseState = (state: RootState) => state.course;

export const isCourseLoadingSelector = createSelector(getCourseState, state => state.loading === LoadingStatusEnum.LOADING);

export const getCourseSelector = createSelector(getCourseState, courseState => courseState.course);

export const getCourseAddressSelector = createSelector(
  getCourseSelector,
  courseData => courseData?.id
    ? `${courseData?.address ?? ''}, ${courseData?.city ? courseData?.city + ',' : ''} ${courseData?.state ?? ''} ${courseData?.zip ?? ''}`
    : ''
);
